export default "__VITE_ASSET___uya17Ec__"